export const autoAuthConstants = {
  TOKEN_VALIDATE_SUCCESS: 'TOKEN_VALIDATE_SUCCESS',
  TOKEN_VALIDATE_FALIURE: 'TOKEN_VALIDATE_FALIURE',

  AUTOAUTH_SIGNUP_SUCCESS: 'AUTOAUTH_SIGNUP_SUCCESS',
  AUTOAUTH_SIGNUP_FALIURE: 'AUTOAUTH_SIGNUP_FALIURE'
};
